import { GroupByIdDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'

import { useCommunitiesClapsFeature } from './useCommunitiesClapsFeature'
import { useGroupsWithPostPermission } from './useGroupsWithPostPermission'

type UseShowKudosCardParams = {
  communitiesDropdown: CommunitiesDropdown
}

export function useShowKudosCard({ communitiesDropdown }: UseShowKudosCardParams) {
  const { canPostSomewhere } = useGroupsWithPostPermission()
  const hasKudosFeatureFlagEnabled = useCommunitiesClapsFeature()

  const groupId: string | undefined =
    communitiesDropdown.strategy === 'group' && typeof communitiesDropdown.value === 'string'
      ? communitiesDropdown.value
      : undefined

  const { data: groupData } = useQuery(GroupByIdDocument, {
    variables: { id: groupId ?? '0' },
    skip: !groupId,
    fetchPolicy: 'cache-first',
  })

  return hasKudosFeatureFlagEnabled && isKudoableView()

  function isKudoableView(): boolean {
    switch (viewKind()) {
      case 'kudo':
      case 'all': {
        return canPostSomewhere
      }
      case 'group': {
        return !!groupData?.posts.group?._policies?.addPosts?.can
      }
      default: {
        return false
      }
    }
  }

  function viewKind() {
    const { value, strategy } = communitiesDropdown
    switch (strategy) {
      case 'type': {
        return String(value).toLowerCase()
      }
      case 'all': {
        return 'all'
      }
      case 'group': {
        return 'group'
      }
      default: {
        throw new Error('Unkwon strategy')
      }
    }
  }
}
